import React from "react";

export type TextareaProps = React.InputHTMLAttributes<HTMLTextAreaElement> & {
    /** This is used to show a label above the input. */
    label?: string;
    /** This is used when there is an error to display the error styles for the input. */
    hasError?: boolean;
    /** This is used when there is an error to display a message to the user. */
    errorMessage?: string;
    /** This is used to disable the hover styles when using the input on certain background colours e.g. grey hover on grey background. */
    disableHoverStyles?: boolean;
};

const Textarea = (props: TextareaProps) => {
    const {
        hasError = false,
        errorMessage,
        className = "",
        label,
        required,
        ...restProps
    } = props;

    return (
        <>
            {label && props.type !== "hidden" && (
                <label
                    htmlFor={restProps?.name || restProps?.id}
                    className={`mb-[10px] text-sm block font-bold`}
                >
                    {label}{" "}
                    {required ? (
                        <span className="text-brand-danger">*</span>
                    ) : (
                        <span className="italic text-[12px] font-normal text-brand-dark-grey">
                            {" "}
                            &#8212; optional
                        </span>
                    )}
                </label>
            )}

            <textarea
                className={`flex min-h-[80px] w-full rounded-[10px] border border-brand-tertiary bg-brand-white px-[15px] py-[11.25px] text-sm text-brand-black placeholder:text-brand-black/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-info disabled:cursor-not-allowed disabled:opacity-25 ${
                    hasError ? "border-brand-danger" : "border-brand-grey"
                } ${errorMessage ? "mb-[5px]" : ""} ${className}`}
                {...restProps}
            />

            {errorMessage && (
                <p className={`text-xs mt-0 mb-[15px] text-brand-danger block`}>
                    {errorMessage}
                </p>
            )}
        </>
    );
};

export default Textarea;
